import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQuery, BackendQueryGenerationToolRatingsArgs } from 'src/types/backend';

const QUERY = gql`
  query GenerationToolRatings($generationTool: GenerationToolEnum!, $projectId: ID!) {
    generationToolRatings(generationTool: $generationTool, projectId: $projectId)
  }
`;

type Variables = BackendQueryGenerationToolRatingsArgs;
type Result = NonNullable<BackendQuery['generationToolRatings']>;

export const generationToolRatings = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
